export default "__VITE_ASSET__0ca0057a__"